import { PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

export const QueryClientContext = (props: PropsWithChildren) => {
    return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>;
};
